import { z } from 'zod';

/** Body of the super-admin sharing toggle endpoints. */
export const SetVisibilitySchema = z.object({ visible: z.boolean() }).strict();

export type SetVisibilityInput = z.infer<typeof SetVisibilitySchema>;
